// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 2개종목비교 그래프 공용 스타일 (CompareChart.js) */

.cmp-chart-panel {
  border: 1px solid #e8ecf0;
  border-radius: 6px;
  padding: 10px 12px 8px;
  background: #fff;
}

.cmp-chart-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 6px;
}

.cmp-chart-header--dual {
  align-items: flex-start;
}

.cmp-dual-left {
  flex: 1 1;
  min-width: 0;
}

.cmp-chart-title {
  font-size: 12px;
  font-weight: 600;
  color: #24292f;
}

.cmp-chart-desc {
  font-size: 10px;
  color: #999;
  margin-top: 3px;
  line-height: 1.4;
}

.cmp-dual-legend {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  font-size: 10px;
  font-weight: 700;
  flex-shrink: 0;
  margin-left: 8px;
  padding-top: 1px;
  white-space: nowrap;
}

/* ── 커스텀 툴팁 ── */
.cmp-tooltip {
  background: rgba(30, 30, 30, 0.88);
  border-radius: 6px;
  padding: 8px 12px;
  color: #fff;
  font-size: 12px;
  line-height: 1.6;
  pointer-events: none;
}
.cmp-tt-date { color: #aaa; font-size: 11px; }
`, "",{"version":3,"sources":["webpack://./src/components/common/CompareChart.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC;EACE,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;AACA,eAAe,WAAW,EAAE,eAAe,EAAE","sourcesContent":["/* 2개종목비교 그래프 공용 스타일 (CompareChart.js) */\n\n.cmp-chart-panel {\n  border: 1px solid #e8ecf0;\n  border-radius: 6px;\n  padding: 10px 12px 8px;\n  background: #fff;\n}\n\n.cmp-chart-header {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-bottom: 6px;\n}\n\n.cmp-chart-header--dual {\n  align-items: flex-start;\n}\n\n.cmp-dual-left {\n  flex: 1;\n  min-width: 0;\n}\n\n.cmp-chart-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #24292f;\n}\n\n.cmp-chart-desc {\n  font-size: 10px;\n  color: #999;\n  margin-top: 3px;\n  line-height: 1.4;\n}\n\n.cmp-dual-legend {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n  font-size: 10px;\n  font-weight: 700;\n  flex-shrink: 0;\n  margin-left: 8px;\n  padding-top: 1px;\n  white-space: nowrap;\n}\n\n/* ── 커스텀 툴팁 ── */\n.cmp-tooltip {\n  background: rgba(30, 30, 30, 0.88);\n  border-radius: 6px;\n  padding: 8px 12px;\n  color: #fff;\n  font-size: 12px;\n  line-height: 1.6;\n  pointer-events: none;\n}\n.cmp-tt-date { color: #aaa; font-size: 11px; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
